import { Clock } from 'lucide-react'

export default function Placeholder({ title, description, icon: Icon = Clock }) {
  return (
    <div>
      <div className="mb-8">
        <div className="font-mono text-[10px] tracking-widest uppercase text-inkMuted mb-1">Coming Soon</div>
        <h1 className="font-black text-2xl uppercase tracking-wide text-ink">{title}</h1>
      </div>
      <div className="bg-canvas border border-border rounded-xl px-6 py-24 flex flex-col items-center justify-center text-center">
        <Icon size={36} className="text-border mb-4" strokeWidth={1} />
        <div className="font-black text-sm uppercase tracking-wide text-inkMuted mb-2">{title}</div>
        <div className="font-mono text-xs text-border max-w-xs leading-relaxed">{description}</div>
      </div>
    </div>
  )
}
